// imports
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { UserService, AuthService } from "../services";
import AppHeader from "../components/AppHeader";
import "./About.css"; // Import CSS for styling

// component About
export default class About extends React.Component {
  /**
   * constructor of About
   * @param {*} props
   */
  constructor(props) {
    super(props);

    this.state = {
      currentUser: AuthService.getCurrentUser(),
      message: "",
      currentUSD: "0.00",
    };
  }

  /**
   * executes on mount
   */
  componentDidMount() {
    // Check if user exists before fetching balance
    if (this.state.currentUser) {
      this.getBalance();
    }
  }

  /**
   * gets user balance from backend
   */
  getBalance() {
    UserService.getUserBalance(this.state.currentUser.username).then(
      (response) => {
        // SAFELY handle the response
        let balance = "0.00";
        
        // Check different possible response structures
        if (response && response.data && response.data.balance !== undefined) {
          balance = parseFloat(response.data.balance).toFixed(2);
        } else if (response && response.data && typeof response.data === 'number') {
          balance = parseFloat(response.data).toFixed(2);
        } else if (response && response.balance !== undefined) {
          balance = parseFloat(response.balance).toFixed(2);
        } else if (response && typeof response === 'number') {
          balance = parseFloat(response).toFixed(2);
        }
        
        this.setState({
          currentUSD: balance,
        });
      },
      (error) => {
        console.error("Error fetching balance:", error);
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        this.setState({
          message: resMessage,
          currentUSD: "0.00" // Set default on error
        });
      }
    );
  }

  /**
   * render-function of About
   */
  render() {
    const { currentUser } = this.state;

    if (currentUser == null) {
      this.props.history.push("/login");
      window.location.reload();
      return null; // Return null while redirecting
    }

    return (
      <Container fluid className="about-container">
        {/* Header */}
        <AppHeader />

        <Row className="about-main-row">
          <Col xs={12} className="about-content-col">
            <div className="about-content-wrapper">
              <h1 className="about-title">About Company</h1>
              
              <div className="about-description">
                <p className="about-paragraph">
                  <strong>SuperCoin</strong>, India's most valuable crypto investment
                  app, is dedicated to make crypto accessible in a simple
                  way. Established in 2018, SuperCoin has solved
                  numerous problems faced by the Indian crypto
                  community with solutions around crypto investing,
                  crypto trading & crypto literacy.
                </p>

                <p className="about-paragraph">
                  The aim of this web application is to deliver an authentic
                  cryptocurrency trading experience. We strive to enable our users
                  to engage in a{" "}
                  <strong className="highlight-text">
                    realistic and risk free trading environment
                  </strong>{" "}
                  which is synced to the latest exchange rates.
                </p>

                <p className="about-paragraph">
                  Please note that this is a{" "}
                  <strong className="highlight-text">prototype</strong>, which means certain
                  processes are yet to be optimised. Nevertheless, we are proud to
                  present a{" "}
                  <strong className="highlight-text">
                    fully functional papertrading experience
                  </strong>{" "}
                  with more than 10 supported currencies - and more to come.
                </p>

                <p className="about-paragraph">
                  How it works: Users will receive their initial start-off funds
                  of <strong className="highlight-text">10,000 dollars</strong> right after
                  registration. From thereon you are free to invest in our
                  supported cryptocurrencies by selling or buying at your leisure.
                  Strategic decisions are supported by our individual trading
                  charts and exchange history. By practising with our simulation,
                  you are able to gain vital knowledge and try out your own
                  strategy first-hand, before even investing a cent of real money.
                </p>

                <p className="about-paragraph">
                  If you face any difficulties with our web app, please do not
                  hesitate to contact our lead developers directly:
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}